import { UserManagement } from '~/enums/UserManagement';
import { fetchUser } from '~/redux/api/methods/rolodex/fetchUser';
import { extractResourceAttributes } from '~/redux/api/transformers/utils';

export const getUser = async () => {
  const response = await fetchUser(null);
  const extractedUsers = extractResourceAttributes(response);
  return extractedUsers.results[0];
};

export const getIsWorkdayUser = async (): Promise<boolean> => {
  const response = await fetchUser(null);
  const extractedUsers = extractResourceAttributes(response);
  const user = extractedUsers.results[0];
  return user.userManagement === UserManagement.Workday;
};
